import { render, staticRenderFns } from "./CompanyEdit.vue?vue&type=template&id=2cecc115&"
import script from "./CompanyEdit.vue?vue&type=script&lang=ts&"
export * from "./CompanyEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cecc115')) {
      api.createRecord('2cecc115', component.options)
    } else {
      api.reload('2cecc115', component.options)
    }
    module.hot.accept("./CompanyEdit.vue?vue&type=template&id=2cecc115&", function () {
      api.rerender('2cecc115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEdit.vue"
export default component.exports